module.exports = {"success":true,"message":"string","code":"string","resultSet":[{"nickname":"Test 1","correctAns":"Answer 1","points":"60","maskedEmail":"test@visa.com ","time":"00:01:00"}]}


//////////////////
// WEBPACK FOOTER
// ./src/mocks/getLeaderBoardMock.json
// module id = 473
// module chunks = 0